import { useEffect, useMemo, useRef } from 'react'
import { debounce } from 'lodash'
import { useAppSelector } from '../store/hooks'
import { createLoadingSelectors } from '../store/actions'

export const useLoading = (actionsToLoad: string[]) => {
  const loadingState = useAppSelector((state) => state.currentLoading)
  const { fetchingSelector, errorSelector } = createLoadingSelectors(actionsToLoad)
  const isFetching = fetchingSelector(loadingState)
  const isError = errorSelector(loadingState)

  return {
    isFetching,
    isError,
  }
}

export const useDebounce = (callback: any) => {
  const ref = useRef(null)

  useEffect(() => {
    ref.current = callback
  }, [callback])

  const debouncedCallback = useMemo(() => {
    const func = () => {
      // @ts-ignore
      ref.current?.()
    }

    return debounce(func, 1000)
  }, [])

  return debouncedCallback
}
